import CommissionsPage from "./commissions/CommissionsPage";

export default CommissionsPage;
